import React, { useState, useEffect } from "react";
import { Select, Row, Col, Form, Upload, Icon, DatePicker, TimePicker, Input, Radio, Button, List, Skeleton, Modal, Switch, message, Checkbox } from "antd";
import { UploadOutlined } from '@ant-design/icons';
import useAuth from "../../hooks/useAuth";
import Mensajes from "../Mensajes/Mensajes";
import axios from "axios";
import moment from 'moment';
import 'moment/locale/es';
import './FormRegistroVerificacion.css';
moment.locale('es');
export default function FormRegistroVerificacion(props) {

    //console.log("PROPS VERIFICACION ****", props)
    const { user } = useAuth();
    
    var tiempoMensaje = 5;

    let i=0;
    let j=0;

    const urlConsultaEmpresasVerificacion = `${localStorage.getItem('SERVERCENTRAL')}/consultaEmpresasVerificacion`;
    const urlConsultaArticulosVerificacion = `${localStorage.getItem('SERVERCENTRAL')}/consultaArticulosVerificacion`;
    const urlGuardaVerificacion = `${localStorage.getItem('SERVERCENTRAL')}/guardaVerificacion`;

    const dateFormat = "DD-MM-YYYY";
    const timeFormat = "HH:mm";
    let regAux = [];
    let tempArt = [];

    const [articulosSeleccionados, setArticulosSeleccionados] = useState(props.artSeleccionados !== null &&
        props.artSeleccionados !== undefined ? props.artSeleccionados : []);
    const handleValuesChange = (e) => {
        //console.log('Value changes', e);
        doRequestEmpresas(e);
    }
    const handleValuesChangeArticulos = (e) => {
       // console.log('Value changes art', e);
        doRequestArticulos(e);
    }

    const [registros, setRegistros] = useState(props.articulosR !== null && props.articulosR !== undefined ? props.articulosR : []);
    /*const [artSeleccionados, setArtSeleccionados] = useState({
        articulo: [],
        checked: []
    });*/
    const { getFieldDecorator } = props.form;

    const [visibleAlert, setVisibleAlert] = useState({
        activado: false,
        tipoMensaje: "",
        mensaje: ""
    });
 const[contador, setContador]=useState({
     mat:0,
     doc:0,
});
    const [cargaArchivo, setCargaArchivo] = useState(props.file);

    const [empresas, setEmpresas] = useState(Object.entries(props.empresas));
    //console.log("EMPRESA", empresas)

    const [selected, setSelected] = useState(props.selected);

    const [modalVisible, setModalVisible] = useState(false);

    const [tipoCaptura, setTipoCaptura] = useState(null);

    const [cambiaTipoCaptura, setCambiaTipoCaptura] = useState(props.verificacion === null || props.verificacion === undefined || props.verificacion.tipoCaptura === null || props.verificacion.tipoCaptura === undefined
        ? null : props.verificacion.tipoCaptura);

    const [disableSwitch, setDisableSwitch] = useState(true);

    const [estatusSwitch, setEstatusSwitch] = useState(null);

    const [tipoClasificacion, setTipoClasificacion] = useState(null);

    const handleGuardaVerificacion = (e) => {
        e.preventDefault();
        props.form.validateFieldsAndScroll((err, values) => {
            // if(articulosSeleccionados ===[])
            //err.checksDocumentos.errors[0].message="error"
            //console.log("values en handleGuardaVerificacion()",err);
            if (!err) {
                //console.log("Object.entries(selected).length:=>", Object.entries(selected).length);
                //console.log("tipoCaptura:=>", tipoCaptura);
                let cuentaAspectosContestados = 0;
                let aspectosRequeridos = tipoCaptura ? props.aspectosRequeridosDocs : props.aspectosRequeridosMats;
                let tipoArticulos = tipoCaptura ? 2 : 1;

               // console.log("prueba value", values)
               // console.log("aspectos requeridos", aspectosRequeridos)
                let cont = 0;
                let cont1 = 0;
                let cont2 = 0;
                let obs = "";
                Object.entries(selected).map((value, index) => {
                    // console.log("value[1]:=>", value[1]); 
                    cont++
                    if (tipoArticulos === value[1].tipoArticulo
                        && (value[1].tipoRespuesta === 1 || value[1].tipoRespuesta === 2)
                        && value[1].respuesta !== null && value[1].respuesta !== undefined)
                        cuentaAspectosContestados++;

                    if (value[1].respuesta !== null && value[1].respuesta !== undefined && (value[1].respuesta === 2 || value[1].respuesta === 0)) {

                        obs = "observaciones-" + cont;
                        cont1++;
                        if (values[obs] !== null && values[obs] !== undefined && values[obs] !== "") {
                            cont2++;
                        }
                        //   console.log( "OBSERVACIONES1",values, "obs", obs );
                        // console.log(values[obs]);
                    }
                })
                //  console.log( "contador1",cont1 );
                // console.log( "contador2",cont2 );
                //console.log("cuentaAspectosContestados:=>", cuentaAspectosContestados);
                //console.log("props.aspectosRequeridos:=>", aspectosRequeridos);
                if (cuentaAspectosContestados === aspectosRequeridos && cont1 === cont2) {
                    //console.log('Received values of form: ', values);
                    setModalVisible(true);
                }

                else if (cuentaAspectosContestados !== aspectosRequeridos && cont1 !== cont2) {

                    message.error("Favor de contestar a todas las preguntas solicitadas y escribir las observaciones correspondientes a las respuestas del tipo No y Parcialmente", tiempoMensaje)
                }
                else if (cuentaAspectosContestados !== aspectosRequeridos && cont1 === cont2) {

                    message.error("Favor de contestar a todas las preguntas solicitadas", tiempoMensaje)
                }
                else if (cuentaAspectosContestados === aspectosRequeridos && cont1 !== cont2) {

                    message.error("Favor de escribir las observaciones correspondientes a las respuestas del tipo No y Parcialmente", tiempoMensaje)
                }

            }
        });
    };


    const onRadioChange = e => {
        let name = e.currentTarget.name;
        let value = e.currentTarget.value;
        let selectRatio = selected[name];
        setSelected({ ...selected, [name]: { respuesta: value, tipoArticulo: selectRatio.tipoArticulo, tipoRespuesta: selectRatio.tipoRespuesta } })
        //console.log("selected:=>", selected);
    };

    const onSwitchChange = (c, e) => {
        //console.log(articulosSeleccionados,"SWITCH c")
        // console.log(tipoCaptura,"SWITCH tc")
        let tipo = -1;
        if (tipoCaptura === true) {
            tipo = 2
        }
        else {
            tipo = 1
        }
        regAux = registros;
        regAux.articulos.map((itemA) => {

            //  console.log("CHECKBOX", itemA)
            if (itemA.tipoArticulo === tipo) {
                itemA.checked = false
            }
        })

        setTipoCaptura(c);
        setArticulosSeleccionados([])
        setRegistros(regAux);

        //console.log("cambio sitch", c)
    };


    //console.log(articulosSeleccionados,"SWITCH", articulosSeleccionados.length, "tipo",tipoClasificacion)  
    const onChangeA = item => {

        //console.log("CHECKBOX9", tempReg, i)
        //console.log("CHECKBOX v", item.target.value)
        // console.log("CHECKBOX c", item.target.checked)

        // tempReg=props.articulosR.articulos.filter((r) => r.checked != false); 

        //console.log("CHECKBOX9a", articulosSeleccionados)
        //setArtSeleccionados(tempReg.articulos.articulo)
        if (item.target.checked === true) {
            articulosSeleccionados.push(item.target.value)
            //console.log("CHECKBOX6", articulosSeleccionados)
        }
        if (item.target.checked === false) {
            tempArt = articulosSeleccionados.filter((r) => r !== item.target.value);
            setArticulosSeleccionados(tempArt)
            //console.log("CHECKBOX7", articulosSeleccionados)
        }

        //artSeleccionados.articulo.push(item.target.value)
        //artSeleccionados.checked.push(item.target.checked)

        regAux = registros;
        regAux.articulos.map((itemA) => {

            //console.log("CHECKBOX", itemA)
            if (itemA.idAdjudicacion === item.target.value) {
                itemA.checked = item.target.checked
            }

        });
        setRegistros(regAux);

        // 

        //setArticulosSeleccionados(artTemp)


    };





    const onSelect = (v) => {
        var result = empresas.reduce(function (map, obj) {
            map[obj[0]] = obj[1];
            return map;
        }, {});

        if (result[v].tipoArticulosEnProd !== 3) {
          //  console.log("entro en onselec !=3")
            //  if (result[v].tipoArticulosEnProd == 1) {
            //console.log("TIPO****1", tipoCaptura, "x4", result[v].tipoArticulosEnProd)
            setTipoCaptura(result[v].tipoArticulosEnProd === 2);
            setCambiaTipoCaptura(result[v].tipoArticulosEnProd === 2);
            setEstatusSwitch(result[v].tipoArticulosEnProd);
            //}


            setDisableSwitch(true);
        }
        else {
            //console.log("entro en onselec 3")
            //console.log("TIPO****3", tipoCaptura, "x", result[v].tipoArticulosEnProd)
            setTipoCaptura(result[v].tipoArticulosEnProd === 3);
            //  tipoCaptura=== false ? setCambiaTipoCaptura(true):setCambiaTipoCaptura(false)
            setCambiaTipoCaptura(true);
            setEstatusSwitch(result[v].tipoArticulosEnProd);
            setDisableSwitch(false);

        }
        setTipoClasificacion(result[v].tipoArticulosEnProd)
        setArticulosSeleccionados([])
        //  console.log("TIPO****3",  estatusSwitch, "x2", disableSwitch)
    }

    const handleModalEnviar = () => {
        let values = props.form.getFieldsValue();
        //console.log("values en handleModalEnviar()", values);
        doRequestGuardaVerificacion(values);
    }

    const handleModalCancel = () => {
        setModalVisible(false);
    }

    const handleClose = () => {
        setVisibleAlert({
            activado: false,
            tipoMensaje: "",
            mensaje: ""
        });
    }

    function doRequestEmpresas(idOple) {
        setVisibleAlert(
            {
                activado: false,
                tipoMensaje: "",
                mensaje: ""
            });
        let data = JSON.stringify({
            idOple: idOple,
            idProceso: user.infoMenu.detalleSelec.idProcesoElectoral,
            idDetalleProceso: user.infoMenu.detalleSelec.idDetalleProceso,
        })
        axios
            .post(
                urlConsultaEmpresasVerificacion, data, {
                headers: {
                    'Authorization': localStorage.getItem('accessToken'),
                    'Content-Type': 'application/json',
                    Accept: "application/json",
                }
            }
            ).then(
                response => {
                    //console.log("ERROR", response)
                    if (response.data.entity.code !== 200 && response.data.entity.code !== 403) {
                        setVisibleAlert(
                            {
                                activado: true,
                                tipoMensaje: "error",
                                mensaje: "10.- Ocurrió un error. Comunícate al CAU"
                            });
                    }
                    else if (response.data.entity.code === 200) {
                        if (response.data.entity.message !== null && response.data.entity.message !== "") {
                            setVisibleAlert(
                                {
                                    activado: true,
                                    tipoMensaje: "warning",
                                    mensaje: response.data.entity.message
                                });
                        }
                        else {
                            setEmpresas(Object.entries(response.data.entity.empresas));
                        }
                    }
                    else {
                        localStorage.clear();
                        // console.log("Borro el local storage");
                        window.location = "/login"
                    }
                }
            ).catch(err => {
                //console.log("Error:=>: doRequestOptions", err)
                if (err.response.status === 403) {
                    localStorage.clear();
                    window.location = "/login"
                    return;
                }
                setVisibleAlert(
                    {
                        activado: true,
                        tipoMensaje: "error",
                        mensaje: "Ha ocurrido un error al realizar la petición solicitada"
                    });
            });
    }

    function doRequestArticulos(idEmpresa) {
        setVisibleAlert(
            {
                activado: false,
                tipoMensaje: "",
                mensaje: ""
            });
        let data = JSON.stringify({
            idEmpresa: idEmpresa,
            idProceso: user.infoMenu.detalleSelec.idProcesoElectoral,
            idDetalleProceso: user.infoMenu.detalleSelec.idDetalleProceso,
            idEstado: user.infoMenu.estadoSelec !== null ? user.infoMenu.estadoSelec.idEstado : user.infoMenu.detalleSelec.idEstado,
            tipoOperacion: props.verificacion != null ? 2 : 1
        })
       // console.log("Data****", data);

        axios
            .post(
                urlConsultaArticulosVerificacion, data, {
                headers: {
                    'Authorization': localStorage.getItem('accessToken'),
                    'Content-Type': 'application/json',
                    Accept: "application/json",
                }
            }
            ).then(
                response => {
                    //console.log("ERROR", response)
                    if (response.data.entity.code !== 200 && response.data.entity.code !== 403) {
                        setVisibleAlert(
                            {
                                activado: true,
                                tipoMensaje: "error",
                                mensaje: "10.- Ocurrió un error. Comunícate al CAU"
                            });
                    }
                    else if (response.data.entity.code === 200) {
                        if (response.data.entity.message !== null && response.data.entity.message !== "") {
                            setVisibleAlert(
                                {
                                    activado: true,
                                    tipoMensaje: "warning",
                                    mensaje: response.data.entity.message
                                });
                        }
                        else {
                          //  console.log("RESPUESTA VERIFICACION*****", response.data.entity)
                                
                            setRegistros(response.data.entity)
                            
                            response.data.entity.articulos.map((item) => (
                                item.tipoArticulo === 2 ? i++:j++
                                                       ))
                                setContador(
                                    {
                                        doc: i,
                                        mat: j, 
                                    });
                                
                            // console.log("RESPUESTA VERIFICACION1", articulos.registros)
                            //    setEmpresas(Object.entries(response.data.entity.empresas));
                        }
                    }
                    else {
                        localStorage.clear();
                        // console.log("Borro el local storage");
                        window.location = "/login"
                    }
                }
            ).catch(err => {
                //console.log("Error:=>: doRequestOptions", err)
                if (err.response.status === 403) {
                    localStorage.clear();
                    window.location = "/login"
                    return;
                }
                setVisibleAlert(
                    {
                        activado: true,
                        tipoMensaje: "error",
                        mensaje: "Ha ocurrido un error al realizar la petición solicitada"
                    });
            });
    }

    //console.log("RESPUESTA VERIFICACION1*****", registros)

    console.log("Contador1", contador.doc, "cont", contador.mat)

    function doRequestGuardaVerificacion(values) {
        setVisibleAlert(
            {
                activado: false,
                tipoMensaje: "",
                mensaje: ""
            });
        const formData = new FormData();
        if (props.verificacion !== undefined && props.verificacion !== null &&
            props.verificacion.idVerificacion !== undefined && props.verificacion.idVerificacion !== null)
            formData.append("verificacion.idVerificacion", props.verificacion.idVerificacion);
        formData.append("verificacion.idOple", values.OPL);
        formData.append("verificacion.idProceso", user.infoMenu.detalleSelec.idProcesoElectoral);
        formData.append("verificacion.idDetalleProceso", user.infoMenu.detalleSelec.idDetalleProceso);
        formData.append("verificacion.idEmpresa", values.empresa);
        formData.append("verificacion.nombreResponsable", values.nombreResponsable);
        formData.append("verificacion.primerApellidoResponsable", values.primerApellidoResponsable);
        if (values.segundoApellidoResponsable !== undefined && values.segundoApellidoResponsable !== null)
            formData.append("verificacion.segundoApellidoResponsable", values.segundoApellidoResponsable);
        formData.append("verificacion.idCargo", values.Cargo);
        //formData.append("verificacion.documentosProduccion", values.documentosProduccion);
        if (values.obsevacioadicional !== undefined && values.obsevacioadicional !== null && values.obsevacioadicional !== "")
            formData.append("verificacion.observaciones", values.obsevacioadicional);
        formData.append("verificacion.fechaVerificacion", values.fechaVerificacion);
        formData.append("verificacion.horaVerificacion", values.horaVerificacion);
        formData.append("verificacion.tipoCaptura", tipoCaptura);
        formData.append("file", values.evidencia.file, values.evidencia.name);
        formData.append("anioProceso", user.infoMenu.detalleSelec.anio);
        formData.append("tipoProceso", user.infoMenu.detalleSelec.tipoProceso);
        formData.append("idProceso", user.infoMenu.detalleSelec.idProcesoElectoral);
        formData.append("idDetalleProceso", user.infoMenu.detalleSelec.idDetalleProceso);
        //console.log("CHECKBOX10:=>", articulosSeleccionados);
        articulosSeleccionados.map((value, index) => {
            formData.append("documentos[" + index + "].idAdjudicacion", value);
        })


        if (tipoCaptura) {
            props.dataAspectosDocs.map((value, index) => {
                /*console.log("value:=>", value);
                console.log(props.form.getFieldValue(`observaciones-${value.idAspecto}`), props.form.getFieldValue(`observaciones-${value.idAspecto}`));
                console.log("selected[]", selected[value.idAspecto]);*/
                formData.append("resultadosVerificacion[" + index + "].idAspecto", value.idAspecto);
                if (selected[value.idAspecto] !== undefined) {
                    formData.append("resultadosVerificacion[" + index + "].respuesta", selected[value.idAspecto].respuesta);
                    formData.append("resultadosVerificacion[" + index + "].tipoArticulo", selected[value.idAspecto].tipoArticulo);
                }
                if (props.form.getFieldValue(`observaciones-${value.idAspecto}`) !== undefined &&
                    props.form.getFieldValue(`observaciones-${value.idAspecto}`) !== null &&
                    props.form.getFieldValue(`observaciones-${value.idAspecto}`) !== "")
                    formData.append("resultadosVerificacion[" + index + "].observaciones", props.form.getFieldValue(`observaciones-${value.idAspecto}`));
            })
        }
        else {
            props.dataAspectosMats.map((value, index) => {
                /*console.log("value:=>", value);
                console.log(props.form.getFieldValue(`observaciones-${value.idAspecto}`), props.form.getFieldValue(`observaciones-${value.idAspecto}`));
                console.log("selected[]", selected[value.idAspecto]);*/
                formData.append("resultadosVerificacion[" + index + "].idAspecto", value.idAspecto);
                if (selected[value.idAspecto] !== undefined) {
                    formData.append("resultadosVerificacion[" + index + "].respuesta", selected[value.idAspecto].respuesta);
                    formData.append("resultadosVerificacion[" + index + "].tipoArticulo", selected[value.idAspecto].tipoArticulo);
                }
                if (props.form.getFieldValue(`observaciones-${value.idAspecto}`) !== undefined &&
                    props.form.getFieldValue(`observaciones-${value.idAspecto}`) !== null &&
                    props.form.getFieldValue(`observaciones-${value.idAspecto}`) !== "")
                    formData.append("resultadosVerificacion[" + index + "].observaciones", props.form.getFieldValue(`observaciones-${value.idAspecto}`));
            })
        }
        //console.log("formdata2", formData)
        //console.log("selected:=>", selected);

        axios
            .post(
                urlGuardaVerificacion, formData, {
                headers: {
                    'Authorization': localStorage.getItem('accessToken'),
                    'Content-Type': 'multipart/form-data',
                    Accept: "application/json",
                }
            }
            ).then(
                response => {
                    //console.log("ERROR guardar", response)
                    if (response.data.entity.code !== 200 && response.data.entity.code !== 403 && (response.data.entity.code !== 406 && response.data.entity.causa !== "No existen correos asociados a los criterios solicitados.")) {
                        setVisibleAlert(
                            {
                                activado: true,
                                tipoMensaje: "error",
                                mensaje: "10.- Ocurrió un error. Comunícate al CAU"
                            });
                    }
                    else if (response.data.entity.code === 406 && response.data.entity.causa === "No existen correos asociados a los criterios solicitados.") {
                        setVisibleAlert(
                            {
                                activado: true,
                                tipoMensaje: "error",
                                mensaje: "No es posible notificar y guardar el registro de verificación, porque no existe un correo asociado. Favor de agregar uno en el Catálogo de correos."
                            });
                    }
                    else if (response.data.entity.code === 200) {
                        if (response.data.entity.message !== null && response.data.entity.message !== "") {
                            setVisibleAlert(
                                {
                                    activado: true,
                                    tipoMensaje: "warning",
                                    mensaje: response.data.entity.message
                                });
                        }
                        else {
                            //props.form.resetFields();
                            window.location = "/produccion/verificaciones"
                        }
                    }
                    else {
                        localStorage.clear();
                        // console.log("Borro el local storage");
                        window.location = "/login"
                    }
                }
            ).catch(err => {
                //console.log("Error:=>: doRequestOptions", err)
                if (err.response.status === 403) {
                    localStorage.clear();
                    window.location = "/login"
                    return;
                }
                setVisibleAlert(
                    {
                        activado: true,
                        tipoMensaje: "error",
                        mensaje: "Ha ocurrido un error al realizar la petición solicitada"
                    });
            });
        setModalVisible(false);
    }





    const propsUpload = {
        multiple: false,
        onRemove: file => {
            setCargaArchivo(file);
        },
        beforeUpload: file => {
            const isPDF = file.type === 'application/pdf';
            const isSomething = file.size > 0;
            const isSize = (file.size / 1024 / 1024) < 50; //Limita hasta 50 MB
            if (!isPDF) {
                /* setVisibleAlert({
                    activado: true,
                    tipoMensaje: "error",
                    //mensaje: "El formato del archivo no corresponde a un CSV. Favor de verificarlo."
                    mensaje: "El formato del archivo no corresponde a un PDF. Favor de borrarlo y cargar uno válido."
                }); */
                message.error("El formato del archivo no corresponde a un PDF. Favor de borrarlo y cargar uno válido.")
                return true;
            }
            if (!isSomething) {
                /* setVisibleAlert({
                    activado: true,
                    tipoMensaje: "error",
                    //mensaje: "El archivo viene vacío. Favor de verificarlo."
                    mensaje: "El archivo se encuentra vacío. Favor de borrarlo y cargar uno válido."
                }); */
                message.error("El archivo se encuentra vacío. Favor de borrarlo y cargar uno válido.")
                return true;
            }
            if (!isSize) {
                /* setVisibleAlert({
                    activado: true,
                    tipoMensaje: "error",
                    //mensaje: "El archivo pesa más de 10 MB. Favor de verificarlo."
                    mensaje: "El archivo pesa más de 50 MB. Favor de borrarlo y cargar uno válido."
                }); */
                message.error("El archivo pesa más de 50 MB. Favor de borrarlo y cargar uno válido.")
                return false;
            }
            else {
                //console.log(file);
                setCargaArchivo(file);
                /*  setVisibleAlert({
                     activado: true,
                     tipoMensaje: "success",
                     mensaje: "El archivo fue pre-cargado exitosamente"
                 }); */
                message.success("El archivo fue pre-cargado exitosamente.")
            }
            return false;
        },
        cargaArchivo,
    };

    useEffect(() => {
        setTipoCaptura(cambiaTipoCaptura)
        //console.log("TIPO****5", cambiaTipoCaptura)
        //console.log("estatus switch", estatusSwitch)
    }, [estatusSwitch]);
   // console.log("estatus switch1", estatusSwitch)

    return (
        <div>
            {visibleAlert.activado ?
                (
                    <div>
                        <Mensajes tipoMensaje={visibleAlert.tipoMensaje} mensaje={visibleAlert.mensaje} handleClose={handleClose} />
                        <br />
                    </div>
                ) : null}
            <Modal
                visible={modalVisible}
                title='¿Está seguro de guardar la información?'
                footer={[
                    <div>
                        <Button onClick={handleModalCancel} className="boton-modal-cancelar"
                        >
                            Cancelar
                        </Button>
                        <Button type="primary"
                            onClick={handleModalEnviar}
                            className="boton-modal-aceptar"
                        >
                            Aceptar
                        </Button>
                    </div>
                ]}
            />
            <h1 className="titulo-verificacion">Verificación de producción</h1>
            <label className="texto-12-verificacion">Los datos con ( <label className="rojo-verificacion">*</label> ) son requeridos.</label>
            <br />
            <br />
            <div>

                <Form id="verificacion" onSubmit={handleGuardaVerificacion} layout="vertical">
                    <Row>

                        <Col span={10}>
                            <Col span={23}>
                                <label className="rojo-verificacion">* </label>
                                <label className="texto-16-verificacion">Nombre del OPL</label>
                            </Col>
                        </Col>
                        <Col span={7}>
                            <Col span={23}>
                                <label className="rojo-verificacion">* </label>
                                <label className="texto-16-verificacion">Fecha de Verificación</label>
                            </Col>
                        </Col>
                        <Col span={7}>
                            <Col span={23}>
                                <label className="rojo-verificacion">* </label>
                                <label className="texto-16-verificacion">Hora de Verificación</label>
                            </Col>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={10}>
                            <Col span={23}>
                                <Form.Item name="OPL" hasFeedback>
                                    {
                                        getFieldDecorator('OPL', {
                                            initialValue: props.verificacion !== undefined && props.verificacion !== null
                                                && props.verificacion.idOple !== undefined && props.verificacion.idOple !== null ?
                                                props.verificacion.idOple.toString() : undefined,
                                            rules: [
                                                {
                                                    required: true,
                                                    message: 'Seleccione una nombre del OPL.',
                                                }
                                            ],
                                        })(
                                            <Select
                                                placeholder="Seleccione una opción"
                                                disabled={
                                                    props.verificacion !== undefined && props.verificacion !== null &&
                                                    props.verificacion.idOple !== undefined && props.verificacion.idOple !== null
                                                }
                                                onChange={handleValuesChange}
                                            >
                                                {Object.entries(props.oples).map((value, index) => {
                                                    return <Select.Option id="opcion" key={value[0]}>{value[1]}</Select.Option>;
                                                })}
                                            </Select>
                                        )}
                                </Form.Item>
                                {/*<Form.Item name="OPL" hasFeedback>
                                    {getFieldDecorator('OPL', {
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Ingrese nombre del OPL.',
                                            }
                                        ],
                                    })(<Input placeholder="Ingresa nombre del OPL"
                                        maxLength={524}
                                    />)}
                                </Form.Item>*/}
                            </Col>
                        </Col>
                        <Col span={7}>
                            <Col span={23}>
                                <Form.Item name="fechaVerificacion" hasFeedback>
                                    {getFieldDecorator('fechaVerificacion', {
                                        initialValue: props.verificacion !== undefined && props.verificacion !== null && props.verificacion.fechaVerificacion !== undefined
                                            ? moment(props.verificacion.fechaVerificacion, dateFormat) : undefined,
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Seleccione la fecha de la verificación.',
                                            }
                                        ],
                                    })(
                                        <DatePicker
                                            placeholder="Seleccionar"
                                            format={dateFormat}
                                            disabledDate={current => {
                                                return current.startOf('day').diff(moment().startOf('day'), 'days') > 0
                                            }}
                                            locale={'es'}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                        </Col>
                        <Col span={7}>
                            <Col span={23}>
                                <Form.Item name="horaVerificacion" hasFeedback>
                                    {getFieldDecorator('horaVerificacion', {
                                        initialValue: props.verificacion !== undefined && props.verificacion !== null && props.verificacion.horaVerificacion !== undefined
                                            ? moment(props.verificacion.horaVerificacion, timeFormat) : undefined,
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Seleccione la hora de la verificación.',
                                            }
                                        ],
                                    })(
                                        <TimePicker
                                            placeholder="Seleccionar"
                                            format={timeFormat}
                                            locale={'es'}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                        </Col>

                    </Row>

                    <Row>
                        <Col span={12}>
                            <Col span={23}>
                                <label className="rojo-verificacion">* </label>
                                <label className="texto-16-verificacion">Empresa</label>
                            </Col>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={12}>
                            <Col span={23}>
                                <Form.Item name="empresa" hasFeedback>
                                    {getFieldDecorator('empresa', {
                                        initialValue: props.verificacion !== undefined && props.verificacion !== null
                                            && props.verificacion.idEmpresa !== undefined && props.verificacion.idEmpresa !== null ?
                                            props.verificacion.idEmpresa.toString() : undefined
                                        ,
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Seleccione una empresa.',
                                            }
                                        ],
                                    })(
                                        <Select
                                            placeholder="Seleccione una opción"
                                            onSelect={onSelect}
                                            disabled={empresas.length <= 1 && props.verificacion !== undefined && props.verificacion !== null
                                                && props.verificacion.idEmpresa !== undefined && props.verificacion.idEmpresa !== null}
                                            onChange={handleValuesChangeArticulos}
                                        >
                                            {empresas.map((value, index) => {
                                                return <Select.Option id="opcion"
                                                    key={value[0]}>{value[1].nombreEmpresa}
                                                </Select.Option>;
                                            })
                                            }
                                        </Select>

                                    )}

                                </Form.Item>

                            </Col>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}>
                            <label className="rojo-verificacion">*</label>
                            <label className="texto-16-verificacion"> Nombre del responsable OPL</label>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}>
                            <label className="texto-14-verificacion">
                                <Icon type="info-circle" theme="filled" className="icono-info" />
                                Al menos uno de los apellidos es obligatorio.
                            </label>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={8}>
                            <Col span={23}>
                                <label className="texto-16-verificacion">Primer apellido</label>
                            </Col>
                        </Col>
                        <Col span={8}>
                            <Col span={23}>
                                <label className="texto-16-verificacion">Segundo apellido</label>
                            </Col>
                        </Col>
                        <Col span={8}>
                            <Col span={23}>
                                <label className="rojo-verificacion">* </label><label className="texto-16-verificacion">Nombre(s)</label>
                            </Col>
                        </Col>
                    </Row>

                    <Row>
                        <Col span={8}>
                            <Col span={23}>
                                <Form.Item name="primerApellidoResponsable" hasFeedback>
                                    {getFieldDecorator('primerApellidoResponsable', {
                                        initialValue: props.verificacion !== undefined && props.verificacion !== null ?
                                            props.verificacion.primerApellidoResponsable : undefined,
                                        rules: [
                                            {
                                                pattern: new RegExp("^[a-zA-ZáéíóúÁÉÍÓÚÑñäëïöüÄËÏÖÜ ]*$"),
                                                message: 'No se permiten caracteres especiales.',
                                            },
                                            {
                                                required: true,
                                                message: 'Ingrese primer apellido del responsable.',
                                            }
                                        ],
                                    })(<Input placeholder="Primer apellido"
                                        maxLength={50}
                                    />)}
                                </Form.Item>
                            </Col>
                        </Col>
                        <Col span={8}>
                            <Col span={23}>
                                <Form.Item name="segundoApellidoResponsable" hasFeedback>
                                    {getFieldDecorator('segundoApellidoResponsable', {
                                        initialValue: props.verificacion !== undefined && props.verificacion !== null
                                            && props.verificacion.segundoApellidoResponsable !== null
                                            ? props.verificacion.segundoApellidoResponsable : null,
                                        rules: [
                                            {
                                                pattern: new RegExp("^[a-zA-ZáéíóúÁÉÍÓÚÑñäëïöüÄËÏÖÜ ]*$"),
                                                message: 'No se permiten caracteres especiales.',
                                            },
                                            {
                                                required: false,
                                                message: 'Ingrese segundo apellido del responsable.',
                                            }
                                        ],
                                    })(<Input placeholder="Segundo apellido"
                                        maxLength={50}
                                    />)}
                                </Form.Item>
                            </Col>
                        </Col>
                        <Col span={8}>
                            <Col span={23}>
                                <Form.Item name="nombreResponsable" hasFeedback>
                                    {getFieldDecorator('nombreResponsable', {
                                        initialValue: props.verificacion !== undefined && props.verificacion !== null
                                            ? props.verificacion.nombreResponsable : null,
                                        rules: [
                                            {
                                                pattern: new RegExp("^[a-zA-ZáéíóúÁÉÍÓÚÑñäëïöüÄËÏÖÜ ]*$"),
                                                message: 'No se permiten caracteres especiales.',
                                            },
                                            {
                                                required: true,
                                                message: 'Ingrese nombre(s) del responsable.',
                                            }
                                        ],
                                    })(<Input placeholder="Nombre(s)"
                                        maxLength={50}

                                    />

                                    )}


                                </Form.Item>

                            </Col>
                        </Col>
                    </Row>

                    <Row>
                        <Col span={12}>
                            <Col span={23}>
                                <label className="rojo-verificacion">* </label>
                                <label className="texto-16-verificacion">Cargo del responsable del OPL</label>
                            </Col>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={12}>
                            <Col span={23}>
                                <Form.Item name="Cargo" hasFeedback>
                                    {getFieldDecorator('Cargo', {
                                        initialValue: props.verificacion !== undefined && props.verificacion !== null
                                            && props.verificacion.idCargo !== undefined && props.verificacion.idCargo !== null ?
                                            props.verificacion.idCargo.toString() : undefined,
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Seleccione un cargo del OPL.',
                                            }
                                        ],
                                    })(
                                        <Select
                                            placeholder="Seleccione una opción"
                                        >
                                            {Object.entries(props.cargos).map((value, index) => {
                                                return <Select.Option id="opcion" key={value[0]}>{value[1]}</Select.Option>;
                                            })}
                                        </Select>
                                    )}
                                </Form.Item>
                                {/*<Form.Item name="Cargo" hasFeedback>
                                    {getFieldDecorator('Cargo', {
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Ingrese cargo del responsable del OPL.',
                                            }
                                        ],
                                    })(<Input placeholder="Ingresa cargo del responsable"
                                        maxLength={524}
                                    />)}
                                </Form.Item>*/}
                            </Col>
                        </Col>
                    </Row>
                    {//console.log("CHECKBOXinicio****", articulosSeleccionados, "tipo", tipoCaptura)
                    }
                    {//console.log("tipo captura", tipoCaptura)
                    }
                    {
                        cambiaTipoCaptura !== null ? (
                            <div>
                                <Row>
                                    <Col span={23}>
                                        {//console.log("TIPO****6", tipoCaptura)
                                        }
                                        <Form.Item label={<label className="texto-16-verificacion">Tipo verificación</label>} name="tipoCaptura" hasFeedback>
                                            <Switch
                                                checkedChildren="Documentos"
                                                unCheckedChildren="Materiales"
                                                defaultChecked={tipoCaptura}
                                                checked={tipoCaptura}
                                                disabled={disableSwitch}
                                                onChange={onSwitchChange}
                                            />
                                        </Form.Item>
                                    </Col>
                                </Row>

                                <Row>
                                    {console.log("tamaño", registros.articulos.length)}
                                    <Col span={23}>
                                        <label className="rojo-verificacion">* </label>
                                        <label className="texto-16-verificacion">
                                            Nombre de (los)
                                            {
                                                tipoCaptura ? " documento(s) " : " material(es) "
                                            }
                                            adjudicados
                                        </label>
                                        <br />
                                        { console.log("Contador2", contador.doc, "cont", contador.mat)}
                                        { (props.verificacion === null || props.verificacion === undefined) ?
                                         (tipoCaptura && contador.doc>0 ) ?
                                        <span> Los artículos enlistados se registrarán en la verificación. Si hubiera artículos faltantes,
                                            es porque no se encuentran adjudicados, en ese caso, se tendrán que adjudicar y hacer una nueva verificación
                                            o modificar una existente.</span>
                                            : (!tipoCaptura && contador.mat>0) 
                                            ? <span> Los artículos enlistados se registrarán en la verificación. Si hubiera artículos faltantes,
                                            es porque no se encuentran adjudicados, en ese caso, se tendrán que adjudicar y hacer una nueva verificación
                                            o modificar una existente.</span>:(tipoCaptura && contador.doc===0)?
                                             <span className="mensaje "> Ya ha terminado de verificar todos los artículos adjudicados a esta empresa.</span>:
                                             (!tipoCaptura && contador.mat ===0) &&
                                             <span className="mensaje "> Ya ha terminado de verificar todos los artículos adjudicados a esta empresa.</span>
                                         :<span> Los artículos enlistados se registrarán en la verificación. Si hubiera artículos faltantes,
                                         es porque no se encuentran adjudicados, en ese caso, se tendrán que adjudicar y hacer una nueva verificación
                                         o modificar una existente.</span>}
                                        
                                          

                                    </Col>
                                </Row>
                                <br />
                                
                                <Row>

                                    <Col>

                                        <Form.Item>

                                            {//console.log("props", props.verificacion)
                                            }
                                            {
                                                props.verificacion === null || props.verificacion === undefined ?
                                                    getFieldDecorator
                                                        ('checksDocumentos', {

                                                            rules: [
                                                                {
                                                                    required: true,
                                                                    message: 'Seleccion el nombre de (los) documento(s) que se están verificando',
                                                                }
                                                            ]
                                                        })
                                                        (
                                                            // <Checkbox.Group>
                                                            <Row>
                                                                {
                                                                    //console.log("CHECKBOX2****", articulosSeleccionados, "tipo", tipoCaptura)
                                                                }
                                                                {tipoCaptura ?
                                                                    registros.articulos.map((item) => (
                                                                        item.tipoArticulo === 2 &&
                                                                        <Col span={24}>
                                                                            <Checkbox defaultChecked={item.checked} checked={item.checked} value={item.idAdjudicacion} onChange={onChangeA}>{item.articulo}</Checkbox>
                                                                        </Col>))
                                                                    : registros.articulos.map((item) => (
                                                                        item.tipoArticulo === 1 &&
                                                                        <Col span={24}>
                                                                            <Checkbox defaultChecked={item.checked} checked={item.checked} value={item.idAdjudicacion} onChange={onChangeA}>{item.articulo}</Checkbox>
                                                                        </Col>
                                                                    ))

                                                                }

                                                            </Row>
                                                            //   </Checkbox.Group>





                                                        )
                                                    : getFieldDecorator
                                                        ('checksDocumentos', {})
                                                        (
                                                            // <Checkbox.Group>
                                                            <Row>
                                                                {
                                                                    //console.log("CHECKBOX2****", articulosSeleccionados, "tipo", tipoCaptura)
                                                                }
                                                                {tipoCaptura ?
                                                                    registros.articulos.map((item) => (
                                                                        item.tipoArticulo === 2 &&
                                                                        <Col span={24}>
                                                                            <Checkbox defaultChecked={item.checked} checked={item.checked} value={item.idAdjudicacion} onChange={onChangeA}>{item.articulo}</Checkbox>
                                                                        </Col>))
                                                                    : registros.articulos.map((item) => (
                                                                        item.tipoArticulo === 1 &&
                                                                        <Col span={24}>
                                                                            <Checkbox defaultChecked={item.checked} checked={item.checked} value={item.idAdjudicacion} onChange={onChangeA}>{item.articulo}</Checkbox>
                                                                        </Col>
                                                                    ))

                                                                }

                                                            </Row>
                                                            //   </Checkbox.Group>





                                                        )
                                            }
                                        </Form.Item>

                                    </Col>
                                </Row>
                                { ((props.verificacion === null || props.verificacion === undefined)&&
                                         (tipoCaptura && contador.doc>0 ) || (!tipoCaptura && contador.mat>0 )) || 
                                         (props.verificacion !== null && props.verificacion !== undefined)?
                                <Row>
                                    <List
                                        header={
                                            <div>
                                                <Row className="header-1-tabla-gris">
                                                    <Col span={9} className="header-1-texto-medium-16-white texto-centrado">
                                                        Aspectos
                                                    </Col>
                                                    <Col span={6} className="header-1-texto-medium-16-white texto-centrado">
                                                        Respuesta
                                                    </Col>
                                                    <Col span={9} className="header-1-texto-medium-16-white texto-centrado">
                                                        Observaciones
                                                    </Col>
                                                </Row>
                                                <Row className="header-2-tabla-gris">
                                                    <Col span={8} className="header-2-texto-normal-16-white texto-centrado">
                                                        {tipoCaptura ? "Documentos" : "Materiales"}
                                                    </Col>
                                                    <Col span={6} offset={1} className="header-2-texto-normal-16-white texto-centrado">
                                                        <Col span={4}>
                                                            Sí
                                                        </Col>
                                                        <Col span={4}>
                                                            No
                                                        </Col>
                                                        <Col span={16} >
                                                            Parcialmente
                                                        </Col>
                                                    </Col>
                                                </Row>
                                            </div>
                                        }
                                        size="large"
                                        loading={!props.loaded}
                                        itemLayout="horizontal"
                                        dataSource={tipoCaptura ? props.dataAspectosDocs : props.dataAspectosMats}
                                        renderItem={(item, index) =>
                                            <List.Item>
                                                <Skeleton title={false} loading={false} active>
                                                    <List.Item.Meta
                                                        description={
                                                            <Row>
                                                                <Col span={8} className="col-aspecto">
                                                                    {item.aspecto}
                                                                </Col>
                                                                <Col span={6} offset={1}>
                                                                    {
                                                                        item.tipoRespuesta === 1 || item.tipoRespuesta === 2 ? (
                                                                            <Col span={4} className="texto-centrado">
                                                                                <Input
                                                                                    key={'si-'+index}
                                                                                    type="radio"
                                                                                    checked={selected[item.idAspecto].respuesta == 1}
                                                                                    onChange={onRadioChange}
                                                                                    name={item.idAspecto}
                                                                                    value={1}
                                                                                />
                                                                            </Col>
                                                                        ) : null}
                                                                    {
                                                                        item.tipoRespuesta === 1 || item.tipoRespuesta === 2 ? (
                                                                            <Col span={4} className="texto-centrado">
                                                                                <Input
                                                                                    key={'no-index'+index}
                                                                                    type="radio"
                                                                                    checked={ selected[item.idAspecto].respuesta == 0}
                                                                                    onChange={onRadioChange}
                                                                                    name={item.idAspecto}
                                                                                    value={0}
                                                                                />
                                                                            </Col>
                                                                        ) : null}
                                                                    <Col span={16} className="texto-centrado">
                                                                        {
                                                                            item.tipoRespuesta === 2 ? (
                                                                                <Input
                                                                                    key={'par-'+index}
                                                                                    type="radio"
                                                                                    checked={selected[item.idAspecto].respuesta == 2}
                                                                                    onChange={onRadioChange}
                                                                                    name={item.idAspecto}
                                                                                    value={2}
                                                                                />
                                                                            ) : null
                                                                        }
                                                                    </Col>
                                                                </Col>
                                                                <Col span={8} offset={1} className="col-aspecto">
                                                                    {
                                                                        item.tipoRespuesta === 1 || item.tipoRespuesta === 2 ? (
                                                                            <Form.Item name={`observaciones-${item.idAspecto}`}>
                                                                                {getFieldDecorator(`observaciones-${item.idAspecto}`, {
                                                                                    initialValue: item.observaciones !== undefined && item.observaciones !== null
                                                                                        ? item.observaciones : null,
                                                                                })(
                                                                                    <Input.TextArea maxLength={250} />
                                                                                )}
                                                                            </Form.Item>
                                                                        )
                                                                            : (
                                                                                <Form.Item name={`observacion-${item.idAspecto}`} hasFeedback>
                                                                                    {getFieldDecorator(`observaciones-${item.idAspecto}`, {
                                                                                        initialValue: item.observaciones !== undefined && item.observaciones !== null
                                                                                            ? item.observaciones : null,
                                                                                        rules: [
                                                                                            {
                                                                                                required: true,
                                                                                                message: 'Campo obligatorio.',
                                                                                            }
                                                                                        ],
                                                                                    })(
                                                                                        <Input.TextArea placeholder="Explicar brevemente"
                                                                                            rows={3} autoSize={{ minRows: 3, maxRows: 3 }}
                                                                                            allowClear={true} maxLength={250} />
                                                                                    )}
                                                                                </Form.Item>
                                                                            )
                                                                    }
                                                                </Col>
                                                            </Row>
                                                        }
                                                    />
                                                </Skeleton>
                                            </List.Item>
                                        }
                                    >
                                    </List>
                                </Row>:""}
                            </div>
                        ) : null
                    }

                    <br />
                    { ((props.verificacion === null || props.verificacion === undefined)&&
                                         (tipoCaptura && contador.doc>0 ) || (!tipoCaptura && contador.mat>0 )) || 
                                         (props.verificacion !== null && props.verificacion !== undefined)?
                 <>   <Row>
                        <Col span={16}>
                            <Col span={23}>
                                <label className="texto-16-verificacion">Observaciones Adicionales</label>
                            </Col>
                        </Col>
                        <Col span={8} className="texto-centrado">
                            <Col span={24}>
                                <label className="rojo-verificacion">* </label>
                                <label className="texto-16-verificacion">Evidencia (.pdf)</label>
                            </Col>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={16}>
                            <Col span={24}>
                                <Form.Item name="obsevacioadicional" hasFeedback>
                                    {getFieldDecorator('obsevacioadicional', {
                                        initialValue: props.verificacion !== undefined && props.verificacion !== null
                                            ? props.verificacion.observaciones : null,
                                    })(
                                        <Input.TextArea placeholder="Si tiene, ingrese observaciones adicionales"
                                            rows={3} autoSize={{ minRows: 3, maxRows: 3 }}
                                            allowClear={true} maxLength={500} />
                                    )}

                                </Form.Item>
                            </Col>
                        </Col>
                        <Col span={8} className="texto-centrado">
                            <Col span={24}>
                                <Form.Item name="evidencia" hasFeedback>
                                    {getFieldDecorator('evidencia', {
                                        initialValue: cargaArchivo !== undefined && cargaArchivo !== null
                                            ? cargaArchivo : null,
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Seleccione la evidencia de verificación.',
                                            }
                                        ],
                                    })
                                        (
                                            <Upload {...propsUpload} accept=".pdf"
                                                fileList={cargaArchivo !== undefined && cargaArchivo !== null ? [cargaArchivo] : []}
                                            >
                                                <Button type="submit" className="subir-evidencia">
                                                    <UploadOutlined /> Subir </Button>
                                            </Upload>
                                        )}
                                </Form.Item>
                            </Col>
                        </Col>
                    </Row></>:""}
                </Form>
            </div>
        </div>
    )
}